import { TitleElastic } from "../effects/title-elastic/title-elastic";
import { BasicEffect } from "../effects/basic-effect/basic-effect";
import { Loader } from "../components/loader/loader";


/**
 *
 * Ciclo di vita
 *
 * 1. Setup
 * 2. Page Ready Event
 * 3. Hide Loader
 *
 */

export class Page {

	page: HTMLElement;
	pageTitle: string;
	debug: boolean;

	basicEffectObserver: IntersectionObserver;
	titleElasticEffectObserver: IntersectionObserver;

	constructor() {
		this.debug = true;
		this.page = document.querySelector('main');
	}


	pageSetup() {

		this.titleElasticEffectObserver = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if ( entry.isIntersecting && !entry.target.classList.contains('animation-done') ) {
					new TitleElastic( <HTMLElement>entry.target );
				}
			});
		}, { threshold: 0 });

		this.basicEffectObserver = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if ( entry.isIntersecting ) {
					new BasicEffect( <HTMLElement>entry.target );
				}
			});
		}, { threshold: .5 });

	}


	pageReady() {
		Loader.hideLoader().then( () => this.loaderHidden() );
	}


	loaderHidden() {

		if (this.page.querySelector('.read-more-block')) {
			import('../components/read-more/read-more').then( c => {
				this.page.querySelectorAll('.read-more-block').forEach( (el: HTMLElement) => new c.ReadMore(el) );
			});
		}

		if (this.page.querySelector('.submenu')) {
			import('../components/submenu/submenu').then( c => new c.Submenu( this.page.querySelector('.submenu') ));
		}

		document.querySelectorAll('*[data-title-elastic-effect]')
			.forEach(target => this.titleElasticEffectObserver.observe(target) );

		document.querySelectorAll('*[basic-effect]')
			.forEach(target => this.basicEffectObserver.observe(target));

	}

}


